import { Component, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Ubicacion } from 'src/app/models/Ubicacion';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-seleccion-ubicacion-default',
    templateUrl: './seleccion-ubicacion-default.component.html',
    styleUrls: ['./seleccion-ubicacion-default.component.css'],
    standalone: false
})
export class SeleccionUbicacionDefaultComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _location = inject(Location);

  private readonly _usuarioService = inject(UsuarioService);
  private readonly _authService = inject(AuthService);
  private readonly _loadingService = inject(LoadingService);

  error = signal<string>('');

  ubicaciones = signal<Ubicacion[]>([]);
  idUbicacionDefault = signal<number>(0);

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this._router.navigate(['/sign-in']);
        return;
      }

      try {
        const res = await firstValueFrom(
          this._usuarioService.getUbicaciones(this._usuarioService.usuario().id!)
        );

        this.ubicaciones.set(res ?? []);

        const ubiTemp = (res ?? []).find(u => u.b_default);
        this.idUbicacionDefault.set(ubiTemp?.id ?? 0);
      } catch (e) {
        console.error(e);
        this.error.set('Error al obtener las ubicaciones.');
      }
    });
  }

  async saveUbicacionDefault(): Promise<void> {
    this.error.set('');

    const all = this.ubicaciones();
    const newId = this.idUbicacionDefault();

    const ubiOld = all.find(u => u.b_default);
    const ubiNew = all.find(u => u.id === newId);

    if (!ubiNew || !newId) {
      this.error.set('Debe seleccionar una ubicación.');
      return;
    }

    await this._loadingService.run(async () => {
      try {
        if (ubiOld && ubiOld.id !== newId) {
          await firstValueFrom(
            this._usuarioService.updateUbicacion({ ...ubiOld, b_default: false })
          );
        }

        await firstValueFrom(
          this._usuarioService.updateUbicacion({ ...ubiNew, b_default: true })
        );

        await this._usuarioService.getUbicacionDefault(this._usuarioService.usuario().id!);

        this.back();
      } catch (e) {
        console.error(e);
        this.error.set('Error al actualizar la ubicación por defecto.');
      }
    });
  }

  back(): void {
    this._location.back();
  }

  openhelp(): void {
    const tooltip = document.getElementById('tooltip-pwa');
    const helpinfo = document.getElementById('helpinfo');
    if (!tooltip || !helpinfo) return;

    if (tooltip.style.display === 'flex') {
      tooltip.style.display = 'none';
    } else {
      helpinfo.textContent = 'Podrás seleccionar la dirección principal donde quieres recibir tus pedidos.';
      tooltip.style.display = 'flex';
    }
  }

  trackByUbiId = (_: number, u: Ubicacion) => u.id ?? _;
}
